import { AbstractControl, ValidatorFn } from '@angular/forms';
import * as moment from 'moment';

/**
 * Validator that triggers if the control value is a date set in the past
 */
export const datePastValidator = (): ValidatorFn => (control: AbstractControl): { [key: string]: any } | null => {
  if (!control) {
    return null;
  }

  return moment(control.value).isBefore(new Date(), 'day') ? {pastDate: {value: control.value}} : null;
};
